export default __webpack_public_path__ + "static/media/about-team-waleed-mussa.63712682.png";